<template>
  <auth-layout>
    <div class="login">
      <h3>ALERT!</h3>
      <img
        src="@/assets/logo/alert.png"
        class="logo"
      />
      <p>
        Your account is locked<br />
        Please check your email to reset your account
      </p>
      <p class="bottom">
        Not receive email yet?<br />
        Re-sent email here
      </p>
      <Button
        style="margin-top: 20px;"
        color="blue"
        display="block"
        type="submit"
        variant="login"
        :loading="loading"
        @click="requestEmail(true)"
      >
        RE-SEND EMAIL
      </Button>
      <p
        v-if="sent"
        class="message"
      >Email Sent!</p>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from '@/components/AuthLayout.vue';
import Button from '@/components/Button.vue';
import api from '@/libs/api';

export default {
  data() {
    return {
      loading: false,
      sent: false,
    };
  },
  components: {
    AuthLayout,
    Button,
  },
  methods: {
    async requestEmail(fromButton) {
      try {
        this.loading = true;
        await api.post('/forgot-password', {
          email: this.$route.params.email,
        });

        if (fromButton) this.sent = true;

        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 300px;
  padding: 20px 0;
}

img.logo {
  height: 70px;
  width: auto;
  display: block;
  margin: 0 auto;
}

h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 25px;
  color: $darkerBlue;
  text-align: center;
  color: $error;
}

p {
  font-size: 12px;
  color: $black;
  margin-top: 45px;
  margin-bottom: 50px;
  text-align: center;

  &.bottom {
    margin-bottom: 0;
  }

  &.message {
    margin-top: 10px;
    margin-bottom: 0;
  }
}

a.forgot-password,
a {
  color: $red;
  text-decoration: none;
  font-size: 14px;
  margin-top: -5px;
  font-weight: 500;
  display: block;
  text-align: right;
}
</style>
